<template>
  <div class="provider-response-forwarding">
    <v-checkbox
      :model-value="enabled"
      :disabled="disabled"
      :readonly="readonly"
      hide-details
      density="compact"
      class="mb-1"
      label="I would like to forward received responses to prescribing provider"
      @update:model-value="onEnabledChange" />
    <v-text-field
      v-if="enabled"
      :model-value="email"
      label="Provider email"
      placeholder="name@clinic.com"
      type="email"
      class="lh--force-white-background"
      :readonly="readonly"
      :disabled="disabled"
      :error-messages="emailErrorMessages"
      @update:model-value="onEmailChange" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { isEmailValid } from "@/utils/validators";

const props = defineProps({
  enabled: { type: Boolean, default: false },
  email: { type: String, default: null },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  showErrors: { type: Boolean, default: false },
});

const emit = defineEmits(["update:enabled", "update:email"]);

const emailErrorMessages = computed(() => {
  if (!props.showErrors || !props.enabled) return null;
  if (!props.email || !String(props.email).trim()) {
    return "Provider email is required when forwarding responses.";
  }
  if (!isEmailValid(props.email)) {
    return "Please enter a valid email address.";
  }
  return null;
});

function onEnabledChange(value) {
  emit("update:enabled", !!value);
}

function onEmailChange(value) {
  emit("update:email", value);
}

function validate() {
  if (!props.enabled) return true;
  return Boolean(props.email && String(props.email).trim() && isEmailValid(props.email));
}

defineExpose({ validate });
</script>
